import React from 'react';
import { css } from 'emotion';
import { useFormikContext } from 'formik';

import { SwitchField } from './SwitchField';

const sectionTextStyle = css`
  text-transform: uppercase;
  font-family: Poppins, sans-serif;
  font-weight: bold;
  color: #ffffff;
  font-size: 0.875rem;
  line-height: 1.3125rem;
`;

const dividerStyle = css`
  border: 1px solid var(--gray);
`;
const marketingOptionsStyle = css`
  background-color: white;
  border-radius: 15px;
`;

const containerStyle = css`
  width:100%;
`;
export const MarketingOptions = (props) => {
    const { show, onClick } = props;
    const formik = useFormikContext();
    console.log('Formik..', formik.values)
    return (
        <div className={containerStyle}>
            <div className={sectionTextStyle}>Marketing settings</div>
            <div className={marketingOptionsStyle}>
            <SwitchField
                name="marketing.sms"
                id="marketing.sms"
                label="Opt In SMS marketing"
            />
            <div className={dividerStyle} />
            <SwitchField
                name="marketing.email"
                id="marketing.email"
                label="Opt In Email marketing"
            />
            <div className={dividerStyle} />
            <SwitchField
                name="marketing.phone"
                id="marketing.phone"
                label="Opt In Phone marketing"
            />
            </div>
        </div>
    );
};
